export const KeywordTrackingAllCss = {
  mainCardHeading: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-30)',
    lineHeight: 'var(--line-height-38)',
    letterSpacing: '0%',
    color: 'var(--color-primary)'
  },
  subCardHeading: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    letterSpacing: '0%',
    color: 'var(--color-primary)'
  },
  cardDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    letterSpacing: '0%',
    color: 'var(--color-text-mid)',
    marginTop: '8px'
  },
  labelTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    letterSpacing: '0%',
    color: 'var(--color-text-secondary)',
    marginBottom: '6px'
  },
  spacerBox: {
    height: '50px'
  },
  mainFooterBox: {
    width: { xs: '100%', lg: 'calc(100% - 250px)' }, // Adjust 250px to match your sidebar width
    height: '78px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: '1px solid var(--color-border-light2)',
    padding: '15px 24px',
    boxShadow: '0px -1px 8px 0px var(--color-shadow-xs)',
    position: 'fixed',
    bottom: 0,
    left: { xs: 0, lg: '250px' }, // Match sidebar width
    backgroundColor: 'white',
    zIndex: 1000
  },
  footerInnerBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  keywordsToTrackTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)'
  },
  footerSpanSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    letterSpacing: '0%',
    color: 'var(--color-primary)'
  },
  footerBtnSx: {
    gap: '8px',
    borderRadius: '6px',
    borderWidth: '1px',
    paddingTop: '12px',
    paddingRight: '18px',
    paddingBottom: '12px',
    paddingLeft: '18px',
    marginRight: '4rem',
    minWidth: '146px'
  },
  textFieldStyle: {
    marginTop: '-2px'
  },
  keywordTrackingToolSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-text-heading)'
  },
  keywordTrackingToolDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-mid)',
    marginTop: '12px'
  },
  keywordTrackingToolBox: {
    width: '100%'
  },
  searchFieldPlaceHolderSx: {
    '& input::placeholder': {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: 'var(--font-size-16)',
      lineHeight: 'var(--line-height-24)',
      color: 'var(--color-text-placeholder)',
      opacity: 1
    }
  }
};

export const KeywordTrackingAnalyzeCss = {
  subContainer: {
    marginTop: '16px',
    display: 'flex',
    gap: '12px',
    alignItems: 'baseline',
    justifyContent: 'space-between'
  },
  btnSx: {
    maxHeight: '44px',
    width: '100%',
    maxWidth: '260px'
  },
  btnBox: {
    display: 'flex',
    gap: '12px'
  },
  locationBox: {
    width: '100%'
  },
  imgStyle: {
    width: 16,
    height: 14
  },
  textAreaBoxSx: {
    position: 'relative',
    width: '100%',
    marginTop: '26px'
  },
  plusIcon: {
    marginRight: '12px'
  },
  textAreaCss: {
    '& .MuiInputBase-root': {
      borderRadius: '6px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      minHeight: '120px' // Ensures input area does not shrink
    }
  },
  textAreaFooterBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  textAreaBtnSx: {
    width: '100%',
    maxWidth: '83px',
    height: '28px',
    gap: '6px',
    paddingTop: '4px',
    paddingRight: '8px',
    paddingBottom: '4px',
    paddingLeft: '8px',
    borderRadius: '6px',
    borderWidth: '1px',
    textTransform: 'none',
    border: '1px solid var(--color-text-muted-purple)'
  },
  textAreaBtnTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)'
  },
  textAreaFooterText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'right'
  },
  keywordInputSx: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--color-text-tertiary)',
      borderRadius: '6px'
    }, // Initial border color
    '& .MuiOutlinedInput-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--color-purple-deep-alt)'
    }, // Border color on hover
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--color-purple-deep-alt)'
    } // Border color on focus
  },
  autoCompleteInput: {
    paddingTop: '3px',
    paddingBottom: '3px',
    Padding: '0px',
    paddingRight: '14px'
  }
};

export const KeywordMonitoringFrequencyCss = {
  btnBox: {
    display: 'flex',
    gap: '12px',
    marginTop: '16px'
  },
  btnSx: {
    maxHeight: '44px',
    width: '100%',
    maxWidth: '260px'
  },
  btnTextSx: {
    width: '100%',
    textAlign: 'left',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-primary)'
  }
};

export const KeywordsYourWebsiteCurrentlyRanksForCss = {
  tableBox: {
    marginTop: '31px'
  },
  headTitleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  keywordRowCellBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  keywordRowText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-purple-rich)'
  },
  urlRowText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-primary)'
  }
};

export const KeywordTrackingResultCss = {
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-30)',
    lineHeight: 'var(--line-height-38)',
    color: 'var(--color-primary)'
  },
  titleBtnSx: {
    height: '48px',
    gap: '8px',
    borderRadius: '6px',
    borderWidth: '1px',
    paddingTop: '12px',
    paddingRight: '18px',
    paddingBottom: '12px',
    paddingLeft: '18px'
  },
  settingIconBox: {
    width: '48px',
    height: '48px',
    gap: '6px',
    borderRadius: '6px',
    borderWidth: '1px',
    border: '1px solid var(--color-text-muted-purple)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  titleBtnMainBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  settingSubIconBox: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  subBoxHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  keywordNum: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-36)',
    lineHeight: 'var(--line-height-38)',
    color: 'var(--color-primary)'
  },
  keywordNumBoxFirst: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  circleBoxSx: {
    width: 12,
    height: 12,
    borderRadius: '50%' // Makes it a circle
  },
  cardDateSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-mid)'
  },
  cardMainSubBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '140px'
  },
  subBoxMinWidth: {
    minWidth: '510px'
  },
  thirdCardSx: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  leftListTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  rightListTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    textAlign: 'end'
  },
  circleListBoxSx: {
    width: 8,
    height: 8,
    borderRadius: '50%' // Makes it a circle
  },
  listItemSubBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  allKeyword: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-text-mid)'
  },
  avgPositionChangeSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-28)'
  },
  positionListBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  rightListChangedTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)'
  },
  keywordChangeBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  positionChangesBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  listBoxSx: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  }
};

export const KeywordTrackingResultTableCss = {
  keywordTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)'
  },
  spanSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-primary)'
  },
  headerBoxSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  headerOptionsBox: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  tableBoxSx: {
    marginTop: '20px'
  },
  deleteMultipleKeywordModal: {
    padding: '32px'
  },
  deleteMultipleKeywordTitle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)',
    textAlign: 'center'
  },
  deleteMultipleKeywordDesc: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-15)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '16px'
  },
  deleteMultipleKeywordSpan: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-15)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-purple-strong)'
  },
  deleteMultipleKeywordBtnBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '24px'
  },
  deleteMultipleKeywordBtn: {
    gap: '6px',
    borderRadius: '6px',
    borderWidth: '1px',
    paddingTop: '10px',
    paddingRight: '18px',
    paddingBottom: '10px',
    paddingLeft: '18px',
    border: '1px solid var(--color-text-muted-purple)'
  },
  deleteMultipleKeywordBtnTwo: {
    gap: '6px',
    borderRadius: '6px',
    paddingTop: '10px',
    paddingRight: '18px',
    paddingBottom: '10px',
    paddingLeft: '18px'
  },
  locationBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  locationIcon: {
    borderRadius: '50%',
    width: '20px',
    height: '20px'
  },
  deleteTableBtn: {
    maxHeight: '44px',
    gap: '6px',
    borderRadius: '6px',
    paddingTop: '10px',
    paddingRight: '18px',
    paddingBottom: '10px',
    paddingLeft: '18px',
    marginRight: '8px'
  },
  cancelBtn: {
    maxHeight: '44px',
    gap: '6px',
    borderRadius: '6px',
    paddingTop: '10px',
    paddingRight: '18px',
    paddingBottom: '10px',
    paddingLeft: '18px',
    borderWidth: '1px',
    border: '1px solid var(--color-text-muted-purple)'
  },
  prePositionSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-mid)'
  },
  positionChangeBox: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  positionChangeTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)'
  },
  deleteMultipleBtnText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-primary)'
  },
  deleteBtnText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-white)'
  }
};

export const SettingModalCss = {
  mainBox: {
    padding: '32px'
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    textAlign: 'center',
    color: 'var(--color-primary)'
  },
  desc: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)'
  },
  span: {
    fontWeight: 600
  },
  applyBtn: {
    maxHeight: '48px',
    gap: '8px',
    paddingTop: '12px',
    paddingRight: '18px',
    paddingBottom: '12px',
    paddingLeft: '18px',
    borderRadius: '6px',
    marginTop: '24px'
  },
  titleBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  closeIconTitleSx: {
    flex: 1,
    marginLeft: '40px'
  }
};

export const keywordTrackingProgressSx = {
  progressTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    color: 'var(--color-text-secondary)'
  },
  paperSx: {
    maxHeight: '38px',
    gap: '8px',
    paddingTop: '12px',
    paddingRight: '16px',
    paddingBottom: '12px',
    paddingLeft: '16px',
    borderRadius: '8px',
    backgroundColor: 'var(--color-secondary)'
  },
  keywordTypoSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: '100%',
    textAlign: 'center',
    color: 'var(--color-primary)',
    width: 'max-content'
  }
};

export const keywordTrackingUpgradeSx = {
  keywordTrackingTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-30)',
    lineHeight: 'var(--line-height-38)',
    color: 'var(--color-primary)',
    marginBottom: '32px'
  },
  unlockTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-text-heading)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    width: '100%',
    maxWidth: '522px',
    color: 'var(--color-text-mid)',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '12px'
  },
  buttonBoxSx: {
    width: '100%',
    maxWidth: '550px',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  btnSx: {
    paddingTop: '12px',
    paddingRight: '8px',
    paddingBottom: '12px',
    paddingLeft: '8px',
    gap: '8px',
    borderRadius: '6px',
    maxHeight: '48px',
    marginBottom: '16px',
    maxWidth: '520px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  learnMoreBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'max-content',
    marginTop: '12px'
  },
  addDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    width: '100%',
    color: 'var(--color-text-mid)',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '12px'
  },
  addSiteImg: {
    width: '100%',
    marginTop: '0rem',
    maxWidth: '865px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  addSiteBtn: {
    maxWidth: '495px',
    maxHeight: '48px',
    gap: '8px',
    borderRadius: '6px',
    borderWidth: '1px',
    paddingTop: '12px',
    paddingRight: '18px',
    paddingBottom: '12px',
    paddingLeft: '18px',
    marginTop: '24px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  addSiteBtnBox: {
    width: '100%',
    display: 'flex'
  },
  upgradeToAgencyAlert: {
    maxWidth: '524px',
    marginLeft: 'auto',
    marginRight: 'auto',
    whiteSpace: 'normal', // Allow text to wrap
    wordBreak: 'break-word' // Break long words if needed
  },
  upgradeBtnBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  }
};
